import { Module } from '../Module';

export class NumberInputRange {
  static INT = {
    MIN: -2147483648,
    MAX: 2147483647
  };
  static LONG = {
    MIN: -9223372036854775000,
    MAX: 9223372036854775000
  };
}

// This is needed for IE8 number and range validation.
Module.instance().directive('tbRangeInputValidator',
  () => {
    return {
      restrict: 'A',
      require: 'ngModel',
       link: (scope: ng.IScope, elm: JQuery, attrs: ng.IAttributes, ctrl: ng.INgModelController) => {
        const NUMBER_REGEXP: RegExp = /^\s*(\-|\+)?(\d+|(\d*(\.\d*)))\s*$/; // From AngularJS v1.2.12

        ctrl.$parsers.push((inputVal: any) => {
          // min and max are inclusive
          const isNumber = NUMBER_REGEXP.test(inputVal);
          const min = attrs['min'] ? parseFloat(attrs['min']) : -1 * Number.MAX_VALUE;
          const max = attrs['max'] ? parseFloat(attrs['max']) : Number.MAX_VALUE;

          inputVal = parseFloat(inputVal);
          ctrl.$setValidity('max', (!isNumber || inputVal <= max));
          ctrl.$setValidity('min', (!isNumber || inputVal >= min));

          return isNumber ? inputVal : undefined;
        });
      }
    };
  }
);
